const FloraAddress = ({ address }) => {
  return (
    <div>
      <h3 className="card-heading "> SIA “Maiznīca Flora”</h3>
      <p className="card-text m-t">
        Ražotne: Vecvaltes, Krimuldas pagasts,
        <br />
        Siguldas novads, Latvija, LV-2144
        <br />
        Reģ nr. 50003251341
        <br />
        Tālrunis: +371 67521291
        <br />
        E-pasts: flora@maiznica.lv
      </p>
    </div>
  )
}

export default FloraAddress
